<template>
    <div id="app">
        <div class="app-content">
            <router-view name="default" v-if="isReloadActive" />
        </div>

        <!--loading -->
        <div v-if="istoLoading" class="loading-mask-backdrop">
            <div>
                <img src="./assets/images/loading.png" class="loading-img" />
            </div>
        </div>

        <!-- ban visit -->
        <!-- <div v-if="isBanVisit" class="loading-mask-backdrop">
            <div class="banVisit" @click="removeBlock()">
                <img src="./assets/images/ban_visit.png" class="ban-img" />
                <div class="banVisitDesc">
                    {{ $t("common.region_ban") }}
                </div>
            </div>
        </div> -->
        <MessageBox
            v-if="msgBox.isShow"
            :title="msgBox.title"
            :body="msgBox.body"
            :hasBtn="msgBox.hasBtn"
            :confirmText="msgBox.btnStr"
            @on-confirm="msgBoxConfirm()"
        >
        </MessageBox>
        <audio
            src="./static/music/loginsound.mp3"
            autoplay
            loop
            v-if="$store.state.common.bgm"
        ></audio>
        <audio src="" id="eventAudio"></audio>
    </div>
</template>

<script>
import EventUtils from "./utils/eventUtils";
import tools from "./utils/fun";
import eventConfig from "./baseConfig/eventConfig";
import ServerManager from "./interface/server";
import PaymenetManager from "./interface/payment";
import MessageBox from "./components/common/modal_message_box";
import AnalystManager from "./utils/analyst";
import AppTools from "./app_tools";
import dataConfig from "./baseConfig/dataConfig";

export default {
    name: "App",
    provide() {
        return {};
    },
    components: {
        MessageBox,
    },
    data() {
        return {
            isBanVisit: false,
            istoLoading: false,
            isReloadActive:true,
            msgBox: {
                isShow: false,
                title: "TIPS",
                body: "",
                hasBtn: 1,
                btnStr: "OK",
            },
            isContinue: false,
            gameInfo: null,
        };
    },
    created() {
        // 根据IP判断邦域限制
        ServerManager.checkBanStatusByIp((status) => {
            this.isBanVisit = status;
            if (dataConfig.isChecking || this.isBanVisit) {
                this.isBanVisit = true;
                dataConfig.isChecking = true;
            } else {
                this.isBanVisit = false;
                dataConfig.isChecking = false;
            }
            this.$store.commit("temp/setIsBanVisit", this.isBanVisit);
            this.reloadHome();
        });
        //更新用户渠道
        this.$store.commit("common/setChannel", window.queryParams["channel"]);
        if (
            dataConfig.googleCheckChannels.indexOf(
                window.queryParams["channel"]
            ) != -1
        ) {
            dataConfig.isChecking = true;
        }
        //非登陆状态，全部为免费状态
        // if (!this.$store.state.user.isLogin) {
        //     dataConfig.isChecking = true;
        // }
        //支付方式
        PaymenetManager.withdrawType(
            this,
            (res) => {
                console.log(res);
            },
            () => {}
        );
        //日志
        AnalystManager.initEvent(this, eventConfig.google.init.END_IFRAME);
    },
    mounted() {
        // loading 状态
        tools.on(eventConfig.LOADING, (status) => {
            this.istoLoading = status ? true : false;
        });
        //继续游戏
        tools.on(eventConfig.CONTINUE_GAME, (data) => {
            this.showToGameMessageBox(data);
        });
        // 登录成功操作
        tools.on(eventConfig.LOGIN_SUC, () => {
            AppTools.setjumpBangbet();
        });
        // android调用事件
        window.getPaymentResult = function (status, data) {
            tools.emit(eventConfig.despositReponse, {
                status: status,
                data: data,
            });
        };
        var self = this;
        window.autoSetVerifyCode = function (code) {
            // self.msgBox.body = "hhhhhhhhhhhhh" + code;
            // self.msgBox.isShow = true;
            tools.emit(eventConfig.autoSetVerifyCode, {
                code: code,
            });
        };

        // sound effect
        tools.on(eventConfig.playEffect, (name) => {
            if (self.$store.state.common.sfx == 1) {
                let buttonAudio = document.getElementById("eventAudio");
                buttonAudio.setAttribute("src", `./static/music/${name}.mp3`);
                buttonAudio.play();
            }
        });

        /**
         * 设置安卓回调函数
         */

        this.setAndroidListner();

        /**
         * 如果从游戏返回，可能存在结算延迟的问题，所以延时处理一下
         */

        AppTools.setActionByFreshUser(this)
            .then(AppTools.setInitData)
            .then(AppTools.checkIsInGame, () => {
                console.log("app.err");
            });

        if (dataConfig.isChecking) {
            this.$store.commit("temp/setIsDemo", true);
        }

        AnalystManager.initEvent(this, eventConfig.google.init.END_RENDER);
    },
    methods: {
        reloadHome(){
            this.isReloadActive = false;
            this.$nextTick(() => {
                this.isReloadActive = true;
            });
        },
        removeBlock() {
            tools.isDev() && (this.isBanVisit = false);
            this.$store.commit("temp/setIsBanVisit", this.isBanVisit);
            //测试
            // this.isBanVisit = false;
        },
        setAndroidListner() {
            if (window.AndroidBridge) {
                let self = this;
                window.loginByAndroidFacebook = function (token, fid) {
                    //self.msgBox.body = "token:" + token;
                    //self.msgBox.isShow = true;
                    if (AnalystManager.uploadFacebookError(token, fid)) {
                        tools.emit(eventConfig.facebookResponse, {
                            facebook_token: token,
                            facebook_userId: fid,
                        });
                    }
                };
                //获取android信息
                this.initAndroidInfo();
            }
        },
        showToGameMessageBox(data) {
            this.isContinue = true;
            this.gameInfo = data;
            this.msgBox.title = this.$t("title.box_warning");
            this.msgBox.body = this.$t("common.CONTINUE_GAME");
            this.msgBox.isShow = true;
        },
        msgBoxConfirm() {
            this.msgBox.isShow = false;
            if (this.isContinue && this.gameInfo) {
                AppTools.toGame(this, this.gameInfo);
                this.isContinue = false;
                this.gameInfo = null;
            }
        },
        setTestMessage(str, isEnd) {
            // if (!str) {
            //     this.msgBox.body = "";
            //     this.msgBox.isShow = false;
            // } else {
            //     this.msgBox.body += str;
            //     this.msgBox.isShow = true;
            // }
        },
        initAndroidInfo() {
            this.setTestMessage();
            if (window.AndroidBridge.h5IsCreated) {
                window.AndroidBridge.h5IsCreated();
                this.setTestMessage("step1:h5IsCreated|");
            }
            //慢的手机初始渲染的时候最好延迟等待一次
            let fHandler = setTimeout(() => {
                if (fHandler) clearTimeout(fHandler);
                fHandler = null;
                AppTools.getGaid(this);
                AppTools.getLiteVersion(this);
                AppTools.setFilter(this);
                AppTools.setjumpBangbet(this);
                //获取firebase token
                let fcmData = AppTools.resetFirebaseToken(this);
                let uuid = fcmData ? tools.trimSpace(fcmData.uuid) : null;
                //上报firebase token
                ServerManager.uploadFirebaseToken(
                    this,
                    fcmData.fcmToken,
                    fcmData.uid,
                    fcmData.uuid,
                    (res) => {
                        this.setTestMessage("step7:uploadFirebaseToken|", true);
                    },
                    (err) => {}
                );
                //日常行为上报
                ServerManager.uploadWebLog(this, 0, uuid);
            }, 1000);
        },
    },
    watch: {},
};
</script>

<style>
@import "./assets/spritesmith-generated/home.css";
@import "./assets/css/index.css";
@import "assets/css/animate.css";

#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /* background-color: #4d4c53; */
    background-image: url(./assets/images/homebg.jpg);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    /* display: flex;
    align-items: center;
    justify-content: center;     */
}

.app-content {
    position: relative;
    
    z-index: 1;
    width: 1334px;
    height: 750px;
    margin: 0 auto;
}

.loading-mask-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 60px;
    z-index: 100000;
    font-weight: bold;
}

@-webkit-keyframes rotation {
    from {
        -webkit-transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
    }
}

.loading-img {
    width: 100px;
    height: 100px;
    -webkit-transform: rotate(360deg);
    animation: rotation 1s linear infinite;
    -moz-animation: rotation 1s linear infinite;
    -webkit-animation: rotation 1s linear infinite;
    -o-animation: rotation 1s linear infinite;
}

.banVisit {
    position: relative;
    width: 800px;
    height: 660px;
    background: #fff;
}

.banVisit .ban-img {
    position: absolute;
    left: 200px;
    top: 10px;
    width: 400px;
}

.banVisit .banVisitDesc {
    position: absolute;
    left: 10%;
    top: 380px;
    width: 85%;
    font-size: 26px;
    color: #000000;
    line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue